// Server URL configuration - ALL environments now use Firebase Functions
const isStaging = window.location.hostname === 'mytassel-staging.web.app';
const isDevelopment = process.env.NODE_ENV === 'development';
const isEmulator = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
const useDeployedFunctions = process.env.REACT_APP_USE_DEPLOYED_FUNCTIONS === 'true';

// Firebase Emulator base (functions port 5001, project my-tassel, region us-central1)
const EMULATOR_API = 'http://127.0.0.1:5001/my-tassel/us-central1/api';

// Firebase Functions URLs - Used by ALL environments now
export const FIREBASE_FUNCTIONS = {
  email: 'https://us-central1-my-tassel.cloudfunctions.net/email',
  stripe: 'https://us-central1-my-tassel.cloudfunctions.net/stripe',
  analytics: 'https://us-central1-my-tassel.cloudfunctions.net/analytics',
  sms: 'https://us-central1-my-tassel.cloudfunctions.net/sms',
  utilities: 'https://us-central1-my-tassel.cloudfunctions.net/utilities',
  contact: 'https://us-central1-my-tassel.cloudfunctions.net/contact'
};

// Server URL - points to local emulator on localhost unless explicitly opted into deployed Functions
export const SERVER_URL = isEmulator && !useDeployedFunctions
  ? EMULATOR_API
  : 'https://us-central1-my-tassel.cloudfunctions.net/api';

// Helper to get service-specific URLs
export const getServiceUrl = (service) => {
  return FIREBASE_FUNCTIONS[service] || `${SERVER_URL}/${service}`;
};

// Helper to get the base URL for the current environment
// Returns current origin for dev/staging, production URL for production
export const getBaseUrl = () => {
  // In development or staging, use the current origin
  if (isDevelopment || isStaging) {
    return typeof window !== 'undefined' ? window.location.origin : 'https://mytassel.com';
  }
  // In production, always use mytassel.com
  return 'https://mytassel.com';
};

// Add other configuration constants here as needed
